module.exports = __webpack_public_path__ + "img/03.f0b877f6.png";